import { render, staticRenderFns } from "./notifications-page.vue?vue&type=template&id=1ad534e3&scoped=true"
import script from "./notifications-page.vue?vue&type=script&lang=js"
export * from "./notifications-page.vue?vue&type=script&lang=js"
import style0 from "./notifications-page.vue?vue&type=style&index=0&id=1ad534e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad534e3",
  null
  
)

export default component.exports